import { css } from 'lit';

export const nsFormFieldStyles = css`
  .form-panel {
    display: flex;
    flex-direction: column;
    gap: var(--wa-space-m);
    padding: var(--wa-space-l);
    border-radius: var(--wa-border-radius-l);
    background: var(--secondary-background-color);
    color: var(--primary-card-text-color);
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: var(--wa-space-2xs);
  }

  .field > label {
    font-size: var(--wa-font-size-m);
    font-weight: 600;
    color: var(--primary-card-text-color);
  }

  .field .hint {
    margin: 0;
    font-size: var(--wa-font-size-xs);
    color: var(--wa-color-text-quiet);
  }

  .field .field-error {
    color: var(--ns-error-text-color, var(--ns-theme-red));
  }

  .field-row {
    display: flex;
    gap: var(--wa-space-m);
  }

  .field-row .field {
    flex: 1;
    min-width: 0;
  }
`;
